import { useMemo } from 'react';
import { getEmbedWidgetConfig } from '../utils/localStorageHelpers';
import { checkIsEmbededEnvironment } from '../utils/functions';

const useWidgetConfig = (baseConfig: WidgetConfig) => {
  const config = useMemo(() => {
    const isEmbedEnv = checkIsEmbededEnvironment();
    if (isEmbedEnv) {
      const storageConfig = getEmbedWidgetConfig(baseConfig.widgetId);
      return storageConfig ?? baseConfig;
    }
    return baseConfig;
  }, [baseConfig]);

  return {
    config,
  };
};

export default useWidgetConfig;
